// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.followlist{
    justify-content: center;
    font-family: Arial, sans-serif;
    width: 100%;
    max-width: 1300px;
    margin: 20px auto;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 12pt;
    overflow: hidden;
    background-color: #fff;
}

.followers {
    max-width: 700px;
    margin: auto;
    font-family: Arial, sans-serif;
    text-align: center;
    
}

h2 {
    font-size: 24px;
    color: #333;
    margin-bottom: 20px;
}

ul {
    list-style: none;
    padding: 0;
}

.follower-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    padding: 5px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #f9f9f9;
}

.profile-pic {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 15px;
}

.follower-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1 1;
}

button {
    padding: 8px 15px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-size: 14px;
}

button.follow {
    background-color: #007bff;
    color: white;
}

button.unfollow {
    background-color: #dc3545;
    color: white;
}
.associated-members-sections{
    margin-top: 30px;
}

.user-info {
    margin-top: 20px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #f9f9f9;
  }
  
  .user-info h2 {
    font-size: 1.2em;
    margin-bottom: 10px;
  }
  
  .user-info p {
    margin: 5px 0;
  }`, "",{"version":3,"sources":["webpack://./src/components/EditFollowers.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf","sourcesContent":[".followlist{\n    justify-content: center;\n    font-family: Arial, sans-serif;\n    width: 100%;\n    max-width: 1300px;\n    margin: 20px auto;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    font-size: 12pt;\n    overflow: hidden;\n    background-color: #fff;\n}\n\n.followers {\n    max-width: 700px;\n    margin: auto;\n    font-family: Arial, sans-serif;\n    text-align: center;\n    \n}\n\nh2 {\n    font-size: 24px;\n    color: #333;\n    margin-bottom: 20px;\n}\n\nul {\n    list-style: none;\n    padding: 0;\n}\n\n.follower-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 15px;\n    padding: 5px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    background-color: #f9f9f9;\n}\n\n.profile-pic {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    margin-right: 15px;\n}\n\n.follower-info {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex: 1;\n}\n\nbutton {\n    padding: 8px 15px;\n    border: none;\n    border-radius: 3px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\nbutton.follow {\n    background-color: #007bff;\n    color: white;\n}\n\nbutton.unfollow {\n    background-color: #dc3545;\n    color: white;\n}\n.associated-members-sections{\n    margin-top: 30px;\n}\n\n.user-info {\n    margin-top: 20px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    background-color: #f9f9f9;\n  }\n  \n  .user-info h2 {\n    font-size: 1.2em;\n    margin-bottom: 10px;\n  }\n  \n  .user-info p {\n    margin: 5px 0;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
